import { render, staticRenderFns } from "./CompanyDetailsBody.vue?vue&type=template&id=4a13aca4&scoped=true&"
import script from "./CompanyDetailsBody.vue?vue&type=script&lang=ts&"
export * from "./CompanyDetailsBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a13aca4",
  null
  
)

export default component.exports